/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Schoolsubgroup3Inputs */



/**

* @param {_Class_Schoolsubgroup3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_schoolsubgroup3 = /** @type {((inputs?: _Class_Schoolsubgroup3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Schoolsubgroup3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Schulgruppe ABSTRACT Nicht benutzen")
});
export { _class_schoolsubgroup3 as "_class_SchoolSubGroup" }